<!-- Lead<loader [showLoader]="showLoader"></loader> -->
<div
  class="m-grid__item m-grid__item--fluid  m-grid m-grid--ver-desktop m-grid--desktop 	m-container m-container--responsive m-container--xxl m-page__container m-body">
  <div class="m-grid__item m-grid__item--fluid m-wrapper">
    <div class="m-content">
      <div class="row">
        <div class="col-sm-12">
          <div class="m-portlet">
            <div class="m-portlet__head">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <h3 class="m-portlet__head-text">Lead  Listing
                  </h3>
                </div>
              </div>
              <div class="m-portlet__head-tools">
                <ul class="m-portlet__nav">
                  <li class="m-portlet__nav-item">
                    <a class="btn btn-primary m-btn m-btn--air m-btn--custom" routerLink="/AddLead">Add Lead </a>
                  </li>
                </ul>
              </div>
            </div>
            <div class="m-portlet__body">
              <div class="table-responsive">
                <div id="example_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
                  <div class="row">
                    <div class="col-sm-12 col-md-6">
                      <!-- <button id="import" (click)="ExportData()" [hidden]="!isDownloadCustomerData"
                        class="btn btn-primary m-btn m-btn--pill m-btn--custom m-btn--air">Export Customer Data</button> -->
                    </div>
                    <div class="col-sm-12 col-md-6 right">
                      <mat-form-field style="width: 50%;" class="pull-right">
                        <mat-label>Search</mat-label>
                        <input matInput (keyup)="SearchParam($event)" (keypress)="AvoidSpace($event)" maxlength="50"
                          placeholder="Search" #input>
                      </mat-form-field>

                    </div>

                  </div>

                  <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)"
                      class="table table-striped- table-bordered table-hover dataTable no-footer" role="grid">

                      <ng-container matColumnDef="Id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Id </th>
                        <td mat-cell *matCellDef="let row">{{row.id}</td>
                      </ng-container>

                      <ng-container matColumnDef="CustomerName">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>  Customer Name </th>
                        <td mat-cell *matCellDef="let row"> {{row.CustomerName}} </td>
                      </ng-container>
                      <ng-container matColumnDef="Organization">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>  Organization </th>
                        <td mat-cell *matCellDef="let row"> {{row.Organization}} </td>
                      </ng-container>
                      <ng-container matColumnDef="CustomerAddress">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>  Customer Address </th>
                        <td mat-cell *matCellDef="let row"> {{row.CustomerAddress}} </td>
                      </ng-container>
                      <!-- <ng-container matColumnDef="Customer Type">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>  Customer Type </th>
                        <td mat-cell *matCellDef="let row"> {{row.CustomerType}} </td>
                      </ng-container> -->

                      <ng-container matColumnDef="Region">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>  Region </th>
                        <td mat-cell *matCellDef="let row"> {{row.RegionName}} </td>
                      </ng-container>

                      <ng-container matColumnDef="LeadStatus">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>  Status </th>
                        <td mat-cell *matCellDef="let row"> {{row.LeadStatus}} </td>
                      </ng-container>
                      <ng-container matColumnDef="EnquiryNumber">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Enquiry Number </th>
                        <td mat-cell *matCellDef="let row"> {{row.EnquiryNumber}} </td>
                      </ng-container>
                      <ng-container matColumnDef="CustomerCode">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Customer Code</th>
                        <td mat-cell *matCellDef="let row"> {{row.CustomerCode}} </td>
                      </ng-container>
                      <ng-container matColumnDef="Action">
                        <th mat-header-cell *matHeaderCellDef> Action </th>
                        <td mat-cell *matCellDef="let row">
                          <a mat-icon-button color="accent" [routerLink]="['/EditViewLead',row?.Lead_Id]" routerLinkActive="active"
                            title="View">
                            <i class="fa fa-eye fa-lg" aria-hidden="true"></i>
                          </a>&nbsp;&nbsp;&nbsp;&nbsp;

                          <!-- <mat-slide-toggle class="example-margin" *ngIf="!row?.IsConvertToProspect" [checked]="row.IsActive" [disabled]="disabled"
                            (change)="UpdateLeadById(row.Lead_Id,row.IsActive)">
                          </mat-slide-toggle>&nbsp;<span *ngIf="!row?.IsConvertToProspect">{{row.IsActive==true ? 'Active' : 'Inactive'}}</span>  -->
                        </td>
                      </ng-container>

                    


                      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    </table>
                    <div *ngIf="dataSource != undefined && (dataSource.filteredData == null || dataSource.filteredData?.length === 0)"
                      class="text-center">No records found</div>

                    <mat-paginator [length]="length" [pageIndex]="pageIndex" [pageSize]="pageSize"
                      [pageSizeOptions]="[5, 10, 25, 100]" (page)="pageEvent($event)">
                    </mat-paginator>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
